/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebAuthnCreateAttestationAllOf
 */
export interface WebAuthnCreateAttestationAllOf {
    /**
     * 
     * @type {object}
     * @memberof WebAuthnCreateAttestationAllOf
     */
    data?: object;
}

/**
 * Check if a given object implements the WebAuthnCreateAttestationAllOf interface.
 */
export function instanceOfWebAuthnCreateAttestationAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebAuthnCreateAttestationAllOfFromJSON(json: any): WebAuthnCreateAttestationAllOf {
    return WebAuthnCreateAttestationAllOfFromJSONTyped(json, false);
}

export function WebAuthnCreateAttestationAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnCreateAttestationAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function WebAuthnCreateAttestationAllOfToJSON(value?: WebAuthnCreateAttestationAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

